export default "__VITE_ASSET__CI9pv$kM__"